export default __webpack_public_path__ + "static/media/techbullion.1e98928b.png";